const ROUTES_WITH_MINIMAL_LAYOUT = [
  "/cv",
  "/auth",
  "/evaluation",
  "/invitation",
  "/plans",
  "/jobboard",
  "/process-questions",
];

const ROUTES_WITHOUT_WIDTH_CONSTRAINTS = ["/auth", "/cv", "/invitation", "/cv-enhance"];

function removeLanguagePrefix(pathname: string, lng: string): string {
  const langPrefix = `/${lng}`;
  if (pathname.startsWith(langPrefix)) {
    return pathname.substring(langPrefix.length);
  }
  return pathname;
}

function pathMatchesRoute(pathWithoutLang: string, route: string): boolean {
  return pathWithoutLang === route || pathWithoutLang.startsWith(`${route}/`);
}

export function matchesMinimalLayoutRoute(
  pathname: string,
  lng: string,
  routesList: string[] = ROUTES_WITH_MINIMAL_LAYOUT
): boolean {
  const pathWithoutLang = removeLanguagePrefix(pathname, lng);
  return routesList.some((route) => pathMatchesRoute(pathWithoutLang, route));
}

export function matchesRouteWithoutWidthConstraints(
  pathname: string,
  lng: string,
  routesList: string[] = ROUTES_WITHOUT_WIDTH_CONSTRAINTS
): boolean {
  const pathWithoutLang = removeLanguagePrefix(pathname, lng);
  return routesList.some((route) => pathMatchesRoute(pathWithoutLang, route));
}

export function shouldUseWidthConstraints(pathname: string, lng: string): boolean {
  return !matchesRouteWithoutWidthConstraints(pathname, lng);
}

export function shouldUseMinimalLayout(
  pathname: string,
  lng: string,
  isProcessUrlRoute: boolean
): boolean {
  return isProcessUrlRoute || matchesMinimalLayoutRoute(pathname, lng);
}

export const LAYOUT_ROUTES = {
  minimal: ROUTES_WITH_MINIMAL_LAYOUT,
  noWidthConstraints: ROUTES_WITHOUT_WIDTH_CONSTRAINTS,
};
